<app-modal class="value-stream-create-modal" [isLoading]="isLoading">
    <ng-container modal-header>
        <h5 class="modal-title" *ngIf="!isEditMode; else editTitle">
            {{ 'admin.valueStreams.create-modal.title' | translate }}
        </h5>
        <ng-template #editTitle>
            <h5 class="modal-title">
                {{ 'admin.valueStreams.update-modal.title' | translate }}
            </h5>
        </ng-template>
    </ng-container>

    <ng-container modal-body>
        <form class="picklist-form" [formGroup]="form">
            <div class="form-group row">
                <app-dropdown-autocomplete
                    formControlName="valueStreamName"
                    [formControl]="form.controls.valueStreamName"
                    [items]="availableValueStreams"
                    displayField="label"
                    valueField="value"
                    emptyText="{{'admin.valueStreams.create-modal.valueStream-input.placeholder' | translate}}"
                    label="{{'admin.valueStreams.create-modal.valueStream-input.label' | translate}}"
                    [showErrors]="showValidations">
                </app-dropdown-autocomplete>
                <app-input
                    formControlName="emailAddress"
                    [formControl]="form.controls.emailAddress"
                    [showErrors]="showValidations"
                    placeholder="{{ 'admin.valueStreams.create-modal.email-input.placeholder' | translate }}"
                    label="{{ 'admin.valueStreams.create-modal.email-input.label' | translate }}">
                </app-input>

            </div>
            <div class="row vs-row">
                <div class="col s12">
                    <app-picklist
                        [source]="lines"
                        [(target)]="valueStream.lines"
                        sourceHeader="{{ 'admin.valueStreams.create-modal.pick-list.leftHeader' | translate }}"
                        targetHeader="{{ 'admin.valueStreams.create-modal.pick-list.rightHeader' | translate }}"
                        infoLabel="{{ 'admin.valueStreams.create-modal.alert.message' | translate }}"
                        (selectionChange)="onLinesSelectionChange($event)">
                    </app-picklist>
                </div>
            </div>
        </form>
    </ng-container>

    <div class="footer" modal-footer>
        <app-button
            type="simple"
            class="waves-effect btn-flat"
            [disabled]="isLoading"
            (click)="modal.close()">
            {{ 'generic.buttons.close' | translate }}
        </app-button>

        <div class="mutators">
            <app-button
                type="primary"
                *ngIf="!isEditMode && shouldRenderModifiers()"
                [disabled]="isLoading"
                (clicked)="createVS()">
                {{ 'admin.valueStreams.create-modal.button.create' | translate }}
            </app-button>

            <app-button
                type="warning"
                *ngIf="isEditMode && shouldRenderModifiers()"
                [disabled]="isLoading"
                (click)="updateVS()">
                {{ 'admin.valueStreams.create-modal.button.update' | translate }}
            </app-button>

            <app-button
                type="danger"
                *ngIf="isEditMode && shouldRenderModifiers()"
                [disabled]="isLoading"
                (click)="deleteVS()">
                {{ 'admin.valueStreams.create-modal.button.delete' | translate }}
            </app-button>
        </div>
    </div>
</app-modal>
